import { useConfigContext } from '@contexts/ConfigContext'

type FlagConfig = {
  auth: {
    enabled: boolean
  }
  locations: {
    displayConversionCouponInfo: boolean
  }
  maintenance: {
    banner: boolean
  }
  prePay: {
    enabled: boolean
  }
  clearPlusPricingUpdate: {
    /**
     * 'bundle'  — legacy integrated bundle (pay combined, rebate on completion)
     * 'prepay'  — pre-pay + promo-code model (TPC-5558 "Remove C+ bundle behavior")
     * Absent/loading defaults to 'bundle' at every call site (safe rollback).
     */
    variant: 'bundle' | 'prepay'
  }
  youngAdultDiscount: {
    showPromoItems: boolean
    isPromoActive: boolean
  }
  updateLookupUx: {
    enabled: boolean
  }
  expiredPrcs: {
    /**
     * Whether the help center lists an expired PRC backed by an I-797 Notice of
     * Action as acceptable. Absent/loading keeps the legacy I-551 wording at
     * every call site (safe rollback).
     */
    displayNewWording: boolean
  }
  layoutRefresh: {
    displayPersonalInformationAdvisoryHeader: boolean
    displayPersonalInformationRevisedLayout: boolean
    displayAuthenticationRevisedLayout: boolean
    displayLocationSearchRevisedLayout: boolean
  }
}

/**
 * hook to always return the requested flag or undefined
 */
export const useFlag = <K extends keyof FlagConfig>(
  flag: K
): FlagConfig[K] | undefined => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { config } = useConfigContext() as any
  if (!config) {
    return undefined
  }
  return config[flag]
}
